import { Fragment, useCallback } from 'react'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { twinFetchPostJSON } from '../../../../../../../utils/globals/data'
import { SetEditDeleteModalTy } from '../../../../../../../utils/hooks/useEditDeleteModal'
import useIsLoading from '../../../../../../../utils/hooks/useIsLoading'
import { ButtonPrimary, ButtonRed, ButtonSecondary } from '../../../../../../../baseComponents/Button'
import { ModalSmallCentered } from '../../../../../../../baseComponents/Modal'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import LoadingSpinner from '../../../../../../../baseComponents/LoaderDecider/LoadingSpinner'

interface ModalSavedSellTicketsProps extends ModalSavedSellTicketsLogicProps {
}

const ModalSavedSellTickets: React.FC<ModalSavedSellTicketsProps> = ({ setOpenModal, ...rest }) => {
    const { deleteSavedSellTickets, loading, keepSavedSellTickets } = useModalSavedSellTicketsLogic({ setOpenModal, ...rest })
    return (
        <ModalSmallCentered opened={true} setOpened={rest.setOpened} className='flex_height'>
            <h2 className='mb-10'><TwinTrans transKey='haveSavedSellTicketsOnCashRegister'>Tienes tickets guardados en esta caja</TwinTrans></h2>
            <span><TwinTrans transKey='wantToDeleteTickets'>¿Quieres borrar los tickets guardados?</TwinTrans></span>
            <div className='flex flex-col justify-center gap-10 mt-35'>
                {loading ?
                    <LoadingSpinner /> :
                    <Fragment>
                        <ButtonRed onClick={deleteSavedSellTickets}>
                            <TwinTrans transKey={'deleteTickets'}>Eliminar tickets</TwinTrans>
                        </ButtonRed>
                        <ButtonPrimary onClick={keepSavedSellTickets}>
                            <TwinTrans transKey={'keepTickets'}>Conservar tickets</TwinTrans>
                        </ButtonPrimary>
                        <ButtonSecondary onClick={() => rest.setOpened(null)}>
                            <TwinTrans transKey={'cancel'}>Cancelar</TwinTrans>
                        </ButtonSecondary>
                    </Fragment>
                }
            </div>
        </ModalSmallCentered>
    )
}

interface ModalSavedSellTicketsLogicProps extends ModalEditComponentProps {
    setOpenModal: SetEditDeleteModalTy
}

const useModalSavedSellTicketsLogic = ({ allRowData, setOpenModal, onSubmit}: ModalSavedSellTicketsLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()

    const deleteSavedSellTickets = useCallback(async () => {
        startLoading?.()
        if (allRowData?.id) {
            const result = await twinFetchPostJSON('/api/app/order/tpv/cashRegister/deleteCashRegisterSavedSellTickets', { id: allRowData?.id })
            if (result) {
                onSubmit?.(false as any, allRowData?.values)
                setOpenModal(null)
            }
        }
        endLoading?.()
    }, [setOpenModal, allRowData, startLoading, endLoading, onSubmit])

    const keepSavedSellTickets = useCallback(async () => {
        startLoading?.()
        const values = { ...allRowData?.values, skipCheckSavedTickets: true}
        onSubmit?.(false as any, values)
        setOpenModal(null)
        endLoading?.()
    }, [startLoading, endLoading, setOpenModal, onSubmit, allRowData])

    return { deleteSavedSellTickets, loading, keepSavedSellTickets }
}


export default ModalSavedSellTickets